/** FNV-1a and Mulberry32; no clocks or Math.random enter authoritative state. */
export function seedHash(s: string) {
  let h = 2166136261;
  for (let i = 0; i < s.length; i++) {
    h ^= s.charCodeAt(i);
    h = Math.imul(h, 16777619);
  }
  return h >>> 0;
}
export function random(s: { rng: number }) {
  s.rng = (s.rng + 0x6d2b79f5) >>> 0;
  let t = s.rng;
  t = Math.imul(t ^ (t >>> 15), t | 1);
  t ^= t + Math.imul(t ^ (t >>> 7), t | 61);
  return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
}
export function shuffled<T>(xs: T[], s: { rng: number }) {
  const a = [...xs];
  for (let i = a.length - 1; i > 0; i--) {
    const j = Math.floor(random(s) * (i + 1));
    [a[i], a[j]] = [a[j], a[i]];
  }
  return a;
}
export function clone<T>(v: T): T {
  return JSON.parse(JSON.stringify(v));
}
export const clamp = (n: number, a: number, b: number) =>
  Math.max(a, Math.min(b, n));
